/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
import { useEffect, useMemo, useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import clsx from "clsx";
import { Common, Icon, ModalInform } from "@/components";
import {
  PATH,
  TIME_FORMAT,
  DeliveryStatusValue,
  SUBSCRIPTION_PRODUCT_TYPE,
  DeliveryLineStatusValue,
} from "@/configuration/globalVariable";
import { useAppDispatch, useAppSelector } from "@/sharedStore/hooks";
import { GoogleMap } from "./Map";
import { ModalOptimize } from "./ModalOptimize";
import { DeliveryList } from "./DeliveryList";
import { StorageAddress } from "./StorageAddress";

import {
  clearManifest,
  moveAndApplyManifestLine,
  moveUnallocatedAndUpdateManifests,
  moveUnallocatedManifestLineInOptimizeGroup,
  replaceManifestsUpdatedETAs,
  updateManifests,
  updateUnallocatedDocuments,
} from "../providers/deliveryManifest/slice";
import {
  fetchAllManifestByDateAsync,
} from "../providers/deliveryManifest/sliceServices";
import {
  manifestsSelector,
  unallocatedDocumentCountSelector,
  deliveryManifestLoading,
  storageAddressSelector,
  deliveryManifestLoaded,
  optimizingGroupsSelector,
  unallocatedDocumentsSelector,
  routesSelector,
} from "../providers/deliveryManifest/selector";
import {
  manifest,
  manifestLine,
  solution,
  unserved,
  // solution,
  storageAddress,
  visits,
  // visits,
} from "../models/DeliveryManifest";
import {
  finishPendingRequests,
  getRouteByIds,
  getRouteETAWithMapIds,
  useGetManifestDetails,
  useGetUnallocatedList,
  useSaveEditingRoutes,
} from "../services/deliveryManifest";
import {
  canModifyRoute,
  checkCompletedDocumentPosition,
  driverName,
  groupUnallocatedManifest,
  isUnallocatedManifest,
  // hoursToISO,
  mergeETAsIntoRoutes,
  refillManifestLinePosition,
} from "../utils";
import {
  useGetETAByManifestId,
  useGetRouteById,
} from "../providers/deliveryManifest/hooks";
import { ModalMoveRouteEditScreen } from "./ModalMoveRouteEditScreen";
import { SnackbarUtils } from "@/utils";
import { ModalChangeDriver } from "./ModalChangeDriver";
import { ModalSwap } from "./ModalSwap";
import { ModalManifestMove } from "./ModalManifestMove";
import { userSelector } from "@/providers/auth/selector";
import { manifestIds } from "../configVariable";
import ReactTooltip from "react-tooltip";
import { ModalAddEmptyRouteScreen } from "./ModalAddEmptyRouteScreen";
import { ModalMoveMultipleRoutesEditScreen } from "./ModalMoveMultipleRoutesEditScreen";
import { ModalReoptimiseRoute } from "./ModalReoptimiseRoute";
import { useReoptimize } from "../services/deliveryOptimize";
import axios from "axios";

export const TabAllocation = ({
  date,
  setDate,
}: {
  date: Date;
  setDate: (date: Date) => void;
}) => {
  const [modalConfirmCancel, setModalConfirmCancel] = useState<
    "refreshList" | "changeDate" | "edit" | string
  >("");
  const [startDate, setStartDate] = useState(date);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [isOpenOptimizeModal, setOpenOptimizeModal] = useState(false);
  const [isOpenAddEmptyRouteModal, setIsOpenAddEmptyRouteModal] =
    useState(false);
  const [isChangeDriverModal, setChangeDriverModal] = useState<manifest>(
    {} as manifest
  );
  const [isSwapModal, setSwapModal] = useState<manifest>({} as manifest);
  const [isManifestMoveModal, setManifestMoveModal] = useState<manifest>(
    {} as manifest
  );
  const [isHideEmptyRoute, setHideEmptyRoute] = useState(true);
  const [isETALoading, setETALoading] = useState(false);
  const [loadingManifests, setLoadingManifests] = useState<string[]>([]);
  const [reoptimisingManifestIds, setReoptimisingManifestIds] = useState<
    string[]
  >([]);
  const [etaLoadingManifestIds, setETALoadingManifestIds] = useState<string[]>(
    []
  );
  const [reoptimizingManifests, setReoptimizingManifests] = useState<
    Map<string, { manifest: manifest; promise: Promise<any> }>
  >(new Map());
  const [reoptimizedResults, setReoptimizedResults] = useState<
    Map<string, { manifest: manifest; solution: solution }>
  >(new Map());
  const [advancedReoptimizingManifests, setAdvancedReoptimizingManifests] =
    useState<Map<string, { manifest: manifest; promise: Promise<any> }>>(
      new Map()
    );
  const [advancedReoptimizedResults, setAdvancedReoptimizedResults] = useState<
    Map<
      string,
      { manifest: manifest; solution: solution; unserved: unserved[] }
    >
  >(new Map());
  const [reoptimiseDialogManifest, setReoptimiseDialogManifest] = useState<
    manifest | undefined
  >();
  const [optimizeIndividualsManifests, setOptimizeIndividualsManifests] = useState<
    manifest[] | undefined
  >();

  const [routesSelected, setRoutesSelected] = useState<string[]>([]);
  const [manifestsOptimizing, setManifestsOptimizing] = useState<manifest[]>(
    []
  );
  const [routesStoppedSelected, setRoutesStoppedSelected] = useState<string[]>(
    []
  );
  const [unallocateChecked, setUnallocateChecked] = useState(false);

  const [manuallyOptimizedManifestLines, setManuallyOptimizedManifestLines] =
    useState<manifestLine[]>([]);
  const [previewingOptimizeGroup, setPreviewingOptimizeGroup] = useState<any>();

  const [selectedManifestLines, setSelectedManifestLines] = useState<
    manifestLine[]
  >([]);
  const [isOpenMoveMultipleModal, setIsOpenMoveMultipleModal] =
    useState<boolean>(false);
  const [isMovingMultiple, setIsMovingMultiple] = useState<boolean>(false);

  const user = useAppSelector(userSelector);
  const manifestsFromStore = useAppSelector(manifestsSelector);
  const manifests = useMemo(
    () => manifestsFromStore ?? [],
    [manifestsFromStore]
  );
  const unallocatedDocuments = useAppSelector(unallocatedDocumentsSelector);
  const routeList = useAppSelector(routesSelector) || [];
  const isDeliveryManifestLoaded = useAppSelector(deliveryManifestLoaded);
  const loading = useAppSelector(deliveryManifestLoading);
  const unallocatedDocumentCount = useAppSelector(
    unallocatedDocumentCountSelector
  );
  const { mutate: fetchUnallocatedList } = useGetUnallocatedList();
  const getRouteById = useGetRouteById();
  const getETAByManifestId = useGetETAByManifestId();
  const getManifestDetails = useGetManifestDetails();

  const storageAddress = useAppSelector(
    storageAddressSelector
  ) as storageAddress;

  const optimizingGroups = useAppSelector(optimizingGroupsSelector);
  const routificSettings = useAppSelector(
    (state) => state.deliverySlice.routificSettings
  );

  const reoptimize = useReoptimize();

  const startRouteETALoading = useCallback((manifestIds: string[]) => {
    if (!manifestIds.length) return;
    setETALoading(true);
    setETALoadingManifestIds((prev) =>
      Array.from(new Set([...prev, ...manifestIds]))
    );
  }, []);

  const finishRouteETALoading = useCallback((manifestIds: string[]) => {
    if (!manifestIds.length) {
      setETALoading(false);
      setETALoadingManifestIds([]);
      return;
    }
    setETALoadingManifestIds((prev) => {
      const remaining = prev.filter((id) => !manifestIds.includes(id));
      if (remaining.length === 0) {
        setETALoading(false);
      }
      return remaining;
    });
  }, []);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();

  const handleChangeDateToFetch = useCallback((date: Date) => {
    setStartDate(date);
  }, []);

  // if (isHideEmptyRoute) {
  //   return item.manifestLines.length;
  // }
  const results = useMemo(
    () =>
      manifests
        ? manifests
            .filter((item: manifest) =>
              isHideEmptyRoute ? item?.manifestLines?.length : true
            )
            .filter((item: manifest) => {
              if (
                item.route?.name &&
                item.route?.name
                  .toUpperCase()
                  .indexOf(searchKeyword.toUpperCase()) > -1
              )
                return true;
              if (
                item.driver?.givenName &&
                item.driver?.givenName
                  .toUpperCase()
                  .indexOf(searchKeyword.toUpperCase()) > -1
              )
                return true;
              if (
                item.driver?.lastName &&
                item.driver?.lastName
                  .toUpperCase()
                  .indexOf(searchKeyword.toUpperCase()) > -1
              )
                return true;
              if (item.manifestLines.length) {
                return item.manifestLines.filter(
                  (manifestLine: manifestLine) =>
                    manifestLine.document.customerTradingName &&
                    manifestLine.document.customerTradingName
                      .toUpperCase()
                      .indexOf(searchKeyword.toUpperCase()) > -1
                ).length;
              }
              return false;
            })
            .sort((a: manifest, b: manifest) => {
              if (a.route.name < b.route.name) {
                return -1;
              }
              if (a.route.name > b.route.name) {
                return 1;
              }
              return 0;
            })
        : [],
    [searchKeyword, manifests, isHideEmptyRoute]
  );

  const unallocatedManifest = useMemo(() => {
    return unallocatedDocuments?.length
      ? groupUnallocatedManifest(unallocatedDocuments)
      : undefined;
  }, [unallocatedDocuments]);

  const manifestsToDisplayOnMap = useMemo(
    () => [
      ...results,
      ...(manifestsOptimizing.length ? manifestsOptimizing : []),
      ...(unallocatedManifest ? [unallocatedManifest] : []),
    ],
    [results, manifestsOptimizing, unallocatedManifest]
  );

  const manifestIdsCanMove = useMemo(() => {
    return manifestsOptimizing.length
      ? results
          .filter((m) => !manifestsOptimizing.some((mo) => mo.id === m.id))
          .map((m) => m.id)
      : undefined;
  }, [manifestsOptimizing, results]);

  const handleEditRoutes = () => {
    const routesActive = [] as manifest[];
    const routesUnActive = [] as manifest[];
    manifests.map((manifest: manifest) => {
      if (routesSelected.includes(manifest.id)) {
        routesActive.push(manifest);
      }
      if (
        !(!routesSelected.includes(manifest.id) && canModifyRoute(manifest))
      ) {
        routesUnActive.push(manifest);
      }
      return manifest;
    });

    navigate(`/${PATH.DELIVERY._}/${PATH.DELIVERY.EDIT_ROUTES}`, {
      state: {
        unallocate: unallocateChecked,
        deliveryDate: date,
        routesActive: unallocateChecked
          ? [{}].concat(routesActive)
          : routesActive,

        routesUnActive,
      },
    });
  };

  const handleSubmitOptimize = () => {
    setOpenOptimizeModal(false);
  };

  const fetchManifestList = (date: any) => {
    finishPendingRequests("RefreshList");
    setManifestsOptimizing([] as manifest[]);
    setUnallocateChecked(false);
    setReoptimizingManifests(new Map());
    setReoptimizedResults(new Map());
    dispatch(clearManifest());
    dispatch(
      fetchAllManifestByDateAsync({
        date: moment(date).format(TIME_FORMAT.REQUEST),
        isFetchETA: true,
      })
    ).then((mnf) => {
      const manifestsPayload = mnf.payload.manifests;
      if (manifestsPayload && manifestsPayload.length) {
        handleFetchandMergeETAIntoRoutes(manifestsPayload);
      }
    });
    fetchUnallocatedList(moment(date).format(TIME_FORMAT.REQUEST), {
      onSuccess: (data) => {
        dispatch(updateUnallocatedDocuments(data.unAllocatedDocs));
      },
    });
  };

  const handleChangeDate = (date: any) => {
    finishPendingRequests("changeDate");
    setDate(date);
    setManifestsOptimizing([]);
    setRoutesSelected([]);
    setRoutesStoppedSelected([]);
    fetchManifestList(date);
    setUnallocateChecked(false);
  };

  useEffect(() => {
    if (!isDeliveryManifestLoaded) {
      fetchManifestList(location.state?.deliveryDate || date);
      if (location.state?.deliveryDate) {
        setDate(new Date(location.state?.deliveryDate));
        window.history.replaceState({}, document.title);
      }
    }
    return () => {
      // clear checkbox component didmount
      finishPendingRequests("cancelFetchETAs");
      setRoutesSelected([]);
      setRoutesStoppedSelected([]);
    };
    // eslint-disable-next-line
  }, []);

  const handleFetchandMergeETAIntoRoutes = (manifestsPayload: manifest[]) => {
    const idsToFetchETA = manifestsPayload
      .map((manifestItem: manifest) => {
        return manifestItem.manifestLines.length ? manifestItem.id : null;
      })
      .filter((id: string | null) => id) as string[];

    const idsToFetch = [] as any;
    const totalRoutes = manifestsPayload.length;
    const routePerGroup = Math.ceil(
      totalRoutes > 30
        ? totalRoutes / Math.ceil(totalRoutes / 10)
        : totalRoutes / 3
    );

    while (idsToFetchETA.length > 0) {
      idsToFetch.push(idsToFetchETA.splice(0, routePerGroup));
    }
    if (idsToFetch.length) {
      startRouteETALoading(idsToFetch.flat());
      // Fetch etas by ids and merge into routes
      getETAsGroup(idsToFetch, manifestsPayload);
    }
  };

  const getETAsGroup = async (idGroup: any[], manifestsPayload: manifest[]) => {
    const allManifestIds = idGroup.flat() as string[];
    let newManifests = [...manifestsPayload] as manifest[];
    await Promise.all(
      idGroup.map((ids) =>
        getRouteETAWithMapIds(ids).then((ETAs) => {
          newManifests = mergeETAsIntoRoutes(newManifests, ETAs) as manifest[];
          dispatch(replaceManifestsUpdatedETAs(newManifests));
        })
      )
    ).catch((error) => {
      console.error(error);
      SnackbarUtils.warning(
        "Some ETA data are temporarily not available. Please try again later."
      );
    });
    finishRouteETALoading(allManifestIds);
  };

  const handleSelectRouteList = (routeId: string, isStopped: boolean) => {
    setRoutesSelected(
      routesSelected.includes(routeId)
        ? routesSelected.filter((rId) => rId !== routeId)
        : routesSelected.concat(routeId)
    );
    if (isStopped) {
      setRoutesStoppedSelected(
        routesStoppedSelected.includes(routeId)
          ? routesStoppedSelected.filter((rId) => rId !== routeId)
          : routesStoppedSelected.concat(routeId)
      );
    }
  };

  const handleCheckAllRoutes = () => {
    if (
      routesSelected.length ===
      manifests.filter((mnf: manifest) =>
        canModifyRoute(mnf)
          ? isHideEmptyRoute
            ? mnf.manifestLines.length > 0
            : true
          : false
      ).length
    ) {
      setRoutesSelected(
        searchKeyword
          ? routesSelected.filter(
              (id: string) => !results.find((i: manifest) => i.id === id)
            )
          : []
      );
      setRoutesStoppedSelected(
        searchKeyword
          ? routesStoppedSelected.filter(
              (id: string) =>
                !results.find(
                  (i: manifest) =>
                    i.id === id && i.status === DeliveryStatusValue.STOPPED
                )
            )
          : []
      );
      unallocatedDocumentCount && setUnallocateChecked(false);
    } else {
      unallocatedDocumentCount && setUnallocateChecked(true);
      setRoutesSelected(
        results
          .filter((mnf: manifest) =>
            canModifyRoute(mnf)
              ? isHideEmptyRoute
                ? mnf.manifestLines.length > 0
                : true
              : false
          )
          .map((item: manifest) => item.id)
      );
      setRoutesStoppedSelected(
        results
          .filter(
            (mnf: manifest) =>
              canModifyRoute(mnf) && mnf.status === DeliveryStatusValue.STOPPED
          )
          .map((item: manifest) => item.id)
      );
    }
  };

  // filter manifest line can check;
  const manifestCanCheck =
    (results &&
      results.length &&
      results.filter((mnf: manifest) =>
        canModifyRoute(mnf)
          ? isHideEmptyRoute
            ? mnf.manifestLines.length > 0
            : true
          : false
      )) ||
    [];
  // check all condition
  const isCheckedAll = manifestCanCheck.length
    ? routesSelected.length === manifestCanCheck.length &&
      manifestCanCheck.length !== 0
    : false;

  useEffect(() => {
    if (isHideEmptyRoute) {
      setRoutesSelected((selectedRouteIds) =>
        selectedRouteIds.filter((id: string) =>
          results.find(
            (mnf: manifest) => mnf.id === id && mnf.manifestLines.length > 0
          )
        )
      );
    }
  }, [isHideEmptyRoute, results]);

  const timeFormat = (time?: null | string) =>
    time && time !== "00:00:00"
      ? moment(time, "HH:mm:ss").format("HH:mm")
      : null;

  const escapeHtml = (value: string) =>
    value
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");

  const isRouteInFlight = (routeId: string) =>
    reoptimizingManifests.has(routeId) ||
    advancedReoptimizingManifests.has(routeId) ||
    loadingManifests.includes(routeId);

  const refreshManifestsAfterServerChange = useCallback(
    async (manifestIds: string[], lineChangeList: any[] = []) => {
      startRouteETALoading(manifestIds);
      try {
        const newManifests: manifest[] = await new Promise((resolve, reject) => {
          getManifestDetails.mutate(
            { ids: manifestIds },
            {
              onSuccess: resolve,
              onError: reject,
            }
          );
        });
        const ETAs = await getRouteETAWithMapIds(manifestIds);
        const manifestsWithETA = mergeETAsIntoRoutes(
          newManifests,
          ETAs
        ) as manifest[];
        dispatch(updateManifests({ manifests: manifestsWithETA }));
        if (lineChangeList.length > 0) {
          dispatch(
            moveAndApplyManifestLine({
              manifestsUpdate: manifestsWithETA,
              lineChangeList,
            })
          );
        }
      } catch (error) {
        console.error(error);
        SnackbarUtils.warning("Some ETA data are temporarily not available.");
      } finally {
        finishRouteETALoading(manifestIds);
      }
    },
    [
      dispatch,
      finishRouteETALoading,
      getManifestDetails,
      startRouteETALoading,
    ]
  );

  // Optimize actions
  const isOptimizeRoutesDisabled =
    !routesSelected.length ||
    (routesStoppedSelected.length >= 1 && routesSelected.length > 1) ||
    !user.isRouteOptimisationAvailable;

  const handleOptimizeRoutes = () => {
    navigate(`/${PATH.DELIVERY._}/${PATH.DELIVERY.OPTIMIZING}`, {
      state: {
        OptimizeIds: routesSelected,
        OptimizeRoutes: routesSelected.map((id) => {
          const route = getRouteById(id);
          const routeETA = getETAByManifestId(id);
          return {
            id: route?.routeId,
            manifestId: id,
            workStartTime: timeFormat(route?.driver.workStartTime),
            workEndTime: timeFormat(route?.driver.workEndTime),
            breakStartTime: timeFormat(route?.driver.breakStartTime),
            breakEndTime: timeFormat(route?.driver.breakEndTime),
            returnToDepot: route?.driver.returnToDepot,
            excludeOptimize: false,
            totalTimeBefore: routeETA?.workingTime,
            totalDistanceBefore: routeETA?.distance,
          };
        }),
        IsApplyUnallocatedDoc: unallocateChecked,
      },
    });
  };

  const getEligibleIndividualOptimizeManifests = () =>
    routesSelected
      .map((id) => getRouteById(id))
      .filter((manifestItem): manifestItem is manifest => {
        if (!manifestItem) return false;
        if (isRouteInFlight(manifestItem.id)) return false;

        const undelivered = manifestItem.manifestLines.filter(
          (line) => line.deliveryStatus !== DeliveryLineStatusValue.COMPLETED
        );
        return undelivered.length > 0;
      });

  const handleOptimizeIndividuals = () => {
    const eligibleManifests = getEligibleIndividualOptimizeManifests();

    if (eligibleManifests.length === 0) {
      SnackbarUtils.warning(
        "No selected routes have undelivered orders available for individual optimisation."
      );
      return;
    }

    setOptimizeIndividualsManifests(eligibleManifests);
  };

  const handleConfirmOptimizeIndividuals = (manifestsToOptimise: manifest[]) => {
    manifestsToOptimise.forEach((manifestItem) => {
      handleAdvancedReoptimiseRoute(manifestItem);
    });
  };
  // Optimize actions

  // Move document to another route
  const [moveModal, setMoveModal] = useState<manifestLine>({} as manifestLine);
  const [manifestCurrent, setManifestCurrent] = useState<manifest>(
    {} as manifest
  );

  const saveEditingRoutes = useSaveEditingRoutes();
  const { isLoading: editIsSaving } = saveEditingRoutes;

  const handleMoveToAnotherRouteClick = useCallback(
    (manifestLine: manifestLine, route: manifest) => {
      setMoveModal(manifestLine);
      setManifestCurrent(route);
    },
    []
  );

  const removeManifestLine = (
    route: manifest,
    manifestLineRemove: manifestLine
  ) => {
    const newManifestLineFilter = route.manifestLines.filter(
      (manifestLine) => manifestLine.id !== manifestLineRemove.id
    );

    return newManifestLineFilter.map((r, index) => {
      return {
        ...r,
        position: route.id === manifestIds.UNALLOCATED ? r.position : index,
      };
    });
  };

  const handleMovetoTarget = (
    manifestTarget: manifest,
    positionNumber: number,
    movingManifestLines: manifestLine[]
  ): manifest => {
    const manifestLines = [...manifestTarget.manifestLines];
    if (positionNumber >= 0 && movingManifestLines.length > 0) {
      manifestLines.splice(positionNumber, 0, ...movingManifestLines);
    }
    const routeObj = {
      ...manifestTarget,
      manifestLines: refillManifestLinePosition(
        manifestLines,
        manifestTarget.id
      ),
    };
    return routeObj;
  };

  const handleMoveManifestLine = (
    target?: manifest,
    position?: string,
    manifestLineMoving?: manifestLine
  ) => {
    const positionNumber = (
      position ? parseInt(position) - 1 : undefined
    ) as number;

    if (manifestLineMoving && positionNumber >= 0 && target) {
      if (checkCompletedDocumentPosition(target, positionNumber)) {
        return SnackbarUtils.error(
          "This position is delivered. Please enter another position number."
        );
      }

      const isUnallocated =
        manifestLineMoving?.manifestId === manifestIds.UNALLOCATED ||
        manuallyOptimizedManifestLines.some(
          (ml) => ml.id === manifestLineMoving?.id
        );

      if (isUnallocated && previewingOptimizeGroup) {
        handleMoveUnallocated(manifestLineMoving, target, positionNumber);
      } else {
        const entryManifest: manifest = {
          ...manifestCurrent,
          manifestLines: removeManifestLine(
            manifestCurrent,
            manifestLineMoving
          ),
          polylines: "",
        };

        const updatedTargetManifest: manifest = {
          ...handleMovetoTarget(target, positionNumber, [manifestLineMoving]),
          polylines: "",
        };

        const manifestsMoved: manifest[] = [
          ...(isUnallocated ? [] : [entryManifest]),
          updatedTargetManifest,
        ];

        saveEditingRoutes.mutate(manifestsMoved, {
          onSuccess: (res) => {
            const movedManifestIds = manifestsMoved.map((mnf) => mnf.id);
            startRouteETALoading(movedManifestIds);
            setLoadingManifests(movedManifestIds);

            setMoveModal({} as manifestLine);
            setManifestCurrent({} as manifest);

            SnackbarUtils.success(
              `Move order <b>#${manifestLineMoving.document.saleDocumentNumber}</b> to route <b>${target?.route.name}</b> successfully.`
            );

            getManifestDetails.mutate(
              {
                ids: manifestsMoved.map((mnf) => mnf.id),
              },
              {
                onSuccess: (newManifests: manifest[]) => {
                  setLoadingManifests(
                    loadingManifests.filter(
                      (id) => !newManifests.some((mnf) => mnf.id === id)
                    )
                  );

                  if (isUnallocated) {
                    dispatch(
                      moveUnallocatedAndUpdateManifests({
                        manifestLineMoving,
                        newManifests,
                      })
                    );
                  } else {
                    dispatch(
                      updateManifests({
                        manifests: newManifests,
                      })
                    );
                  }

                  // refetch ETA and polyline
                  getRouteETAWithMapIds(newManifests.map((mnf) => mnf.id))
                    .then((ETAs) => {
                      const manifestsMovedReplaceETA = mergeETAsIntoRoutes(
                        newManifests,
                        ETAs
                      ) as manifest[];
                      // Replace polyline
                      dispatch(
                        moveAndApplyManifestLine({
                          manifestsUpdate: manifestsMovedReplaceETA,
                          lineChangeList: res.lineChangeList,
                        })
                      );
                      finishRouteETALoading(movedManifestIds);
                    })
                    .catch((error) => {
                      console.error(error);
                      SnackbarUtils.warning(
                        "Some ETA data are temporarily not available. Please try again later."
                      );
                      finishRouteETALoading(movedManifestIds);
                    });
                },
                onError: (error) => {
                  console.error(error);
                  SnackbarUtils.error(
                    "The loading process failed. Please try again."
                  );
                  finishRouteETALoading(movedManifestIds);
                },
              }
            );
          },
          onError: (error) => {
            console.error(error);
            SnackbarUtils.error(
              "The moving process might be failed. Please try again."
            );
          },
        });
      }
    }
  };

  const handleMoveUnallocated = (
    manifestLineMoving: manifestLine,
    manifestTarget: manifest,
    positionNumber: number
  ) => {
    if (
      !manuallyOptimizedManifestLines.some(
        (ml) => ml.id === manifestLineMoving.id
      )
    ) {
      setManuallyOptimizedManifestLines((prev) => [
        ...prev,
        manifestLineMoving,
      ]);
    }

    if (previewingOptimizeGroup) {
      dispatch(
        moveUnallocatedManifestLineInOptimizeGroup({
          manifestLineMoving,
          targetManifest: manifestTarget,
          targetPosition: positionNumber,
          jobId: previewingOptimizeGroup?.jobId,
        })
      );
    } else if (optimizingGroups.length === 0) {
      // TODO: move unallocated manifest line to another route
    }

    setMoveModal({} as manifestLine);
    setManifestCurrent({} as manifest);
  };

  const alertEditedMsg =
    "There is a pending optimization. Leaving the page or changing date will discard the optimized results. Are you sure?";

  useEffect(() => {
    if (optimizingGroups.length) {
      const arr = [] as manifest[];
      optimizingGroups.map((optimizeGroup: any) => {
        if (optimizeGroup.solution) {
          optimizeGroup.manifests.map((mnf: manifest) => {
            // const slt = optimizeGroup.solution.find(
            //   (solution: solution) => solution.manifestId === mnf.id
            // );
            arr.push(mnf);
            // arr.push({
            //   ...mnf,
            //   distance: slt.totalDistanceAfter,
            //   workingTime: slt.totalTimeAfter,
            //   manifestLines:
            //     slt?.visits.map((vs: visits) => {
            //       return {
            //         ...vs.manifestLine,
            //         position: vs.position - 1,
            //         arrivalTime: hoursToISO(vs.arrivalTime),
            //       };
            //     }) || [],
            //   polylines: slt?.polyline,
            // });
            return mnf;
          });
        }
        return optimizeGroup;
      });
      setManifestsOptimizing(arr);
    } else {
      setManifestsOptimizing([] as manifest[]);
    }

    window.onbeforeunload = (event) => {
      if (optimizingGroups.length) {
        const e = event || window.event;
        if (e) {
          e.returnValue = alertEditedMsg;
        }
        return alertEditedMsg;
      }
    };
  }, [optimizingGroups]);

  const handleRefreshList = () => {
    if (optimizingGroups.length) {
      setModalConfirmCancel("refreshList");
    } else {
      fetchManifestList(date);
    }
  };

  const handleEditRoutesFirst = () => {
    if (optimizingGroups.length) {
      setModalConfirmCancel("edit");
    } else {
      handleEditRoutes();
    }
  };

  const handleChangeDateFirst = (date: any) => {
    if (optimizingGroups.length) {
      setModalConfirmCancel(date);
    } else {
      handleChangeDate(date);
    }
  };

  const handleCancelOptimize = () => {
    if (modalConfirmCancel === "refreshList" || modalConfirmCancel === "") {
      fetchManifestList(date);
    }
    if (modalConfirmCancel === "edit") {
      handleEditRoutes();
    }
    if (
      modalConfirmCancel &&
      !["refreshList", "edit"].includes(modalConfirmCancel)
    ) {
      handleChangeDate(modalConfirmCancel);
    }
    setModalConfirmCancel("");
  };

  // Helper function to prepare reoptimization data for a single manifest
  const prepareReoptimizationData = (manifestToReoptimise: manifest) => {
    // Filter out completed/delivered manifest lines
    const manifestLinesToReoptimise = manifestToReoptimise.manifestLines.filter(
      (line) => line.deliveryStatus !== DeliveryLineStatusValue.COMPLETED
    );

    if (manifestLinesToReoptimise.length === 0) {
      return null;
    }

    // Create solution with only undelivered orders
    const solution = {
      manifestId: manifestToReoptimise.id,
      route: {
        manifest_id: manifestToReoptimise.id,
        driver_name: driverName(manifestToReoptimise.driver),
        work_start_time: timeFormat(manifestToReoptimise?.driver.workStartTime) || "00:00",
        work_end_time: timeFormat(manifestToReoptimise?.driver.workEndTime) || "23:59",
        break_start_time: timeFormat(manifestToReoptimise?.driver.breakStartTime),
        break_end_time: timeFormat(manifestToReoptimise?.driver.breakEndTime),
        return_to_depot: manifestToReoptimise?.driver.returnToDepot || false,
        exclude_optimize: false,
        address: null,
        total_order: manifestLinesToReoptimise.length,
        lat: null,
        lng: null,
        id: manifestToReoptimise.routeId,
        name: manifestToReoptimise.route.name,
        defaultDriverId: manifestToReoptimise.route.defaultDriverId,
        colour: manifestToReoptimise.route.colour,
        isValidInvoice: manifestToReoptimise.route.isValidInvoice,
        isContainOrder: manifestToReoptimise.route.isContainOrder,
        totalOrders: manifestLinesToReoptimise.length,
      },
      visits: manifestLinesToReoptimise.map((line, index) => ({
        manifestLine: line,
        position: index + 1,
        arrivalTime: line.arrivalTime || "",
        finishTime: line.finishTime || "",
        longitude: line.longitude,
        latitude: line.latitude,
        duration: line.stopTime || 0,
      })),
      startTime: manifestToReoptimise.startTime,
      totalDistanceAfter: manifestToReoptimise?.distance || 0,
      totalTimeAfter: manifestToReoptimise?.workingTime || 0,
      applyForFuture: false,
      endTime: manifestToReoptimise.endTime,
      polyline: manifestToReoptimise.polylines || "",
      totalCapacityValue: manifestToReoptimise.totalCapacityValue || [],
      maxCapacityValue: manifestToReoptimise.maxCapacityValue || [],
    };

    // Prepare optimize settings — spread routificSettings first so per-route values win (matches Optimizing.tsx)
    const optimizeSettings = {
      ...routificSettings,
      routes: [{
        id: manifestToReoptimise?.routeId || "",
        manifestId: manifestToReoptimise.id,
        workStartTime: timeFormat(manifestToReoptimise?.driver.workStartTime) || "00:00",
        workEndTime: timeFormat(manifestToReoptimise?.driver.workEndTime) || "23:59",
        breakStartTime: timeFormat(manifestToReoptimise?.driver.breakStartTime) || "",
        breakEndTime: timeFormat(manifestToReoptimise?.driver.breakEndTime) || "",
        returnToDepot: manifestToReoptimise?.driver.returnToDepot || false,
        excludeOptimize: false,
        totalTimeBefore: manifestToReoptimise?.workingTime || 0,
        totalDistanceBefore: manifestToReoptimise?.distance || 0,
        strictStart: false,
      }],
    };

    return { solution, optimizeSettings, manifest: manifestToReoptimise };
  };

  // Handle reoptimise single route (can be called multiple times in parallel)
  const handleReoptimiseRoute = (manifestToReoptimise: manifest) => {
    if (isRouteInFlight(manifestToReoptimise.id)) {
      SnackbarUtils.info("This route is already being reoptimised.");
      return;
    }

    // Prepare reoptimization data
    const reoptimizationData = prepareReoptimizationData(manifestToReoptimise);

    if (!reoptimizationData) {
      SnackbarUtils.warning("No undelivered orders to reoptimise in this route.");
      return;
    }

    // Show loading state for this manifest
    setLoadingManifests((prev) => [...prev, manifestToReoptimise.id]);
    setReoptimisingManifestIds((prev) => [...prev, manifestToReoptimise.id]);

    // Create reoptimize promise using axios directly
    const reoptimizePromise = axios
      .post("Delivery/Reoptimize", {
        solution: [reoptimizationData.solution],
        unserved: [],
        optimizeSettings: reoptimizationData.optimizeSettings,
      })
      .then((res) => {
        const responseData = res?.data?.data || res?.data;
        if (res.data.errorMessage || responseData?.error) {
          throw new Error(responseData?.error || res.data.errorMessage || "Reoptimising route failed.");
        }
        
        if (responseData.solution && responseData.solution.length > 0) {
          return {
            manifest: reoptimizationData.manifest,
            solution: responseData.solution[0] as solution,
          };
        } else {
          throw new Error("No solution returned.");
        }
      });

    // Add to reoptimizing collection
    setReoptimizingManifests((prev) => {
      const newMap = new Map(prev);
      newMap.set(manifestToReoptimise.id, {
        manifest: manifestToReoptimise,
        promise: reoptimizePromise,
      });
      return newMap;
    });

    // Handle the promise result
    reoptimizePromise
      .then((result) => {
        // Add to successful results
        setReoptimizedResults((prev) => {
          const newMap = new Map(prev);
          newMap.set(manifestToReoptimise.id, result);
          return newMap;
        });

        // Remove from reoptimizing collection
        setReoptimizingManifests((prev) => {
          const newMap = new Map(prev);
          newMap.delete(manifestToReoptimise.id);
          return newMap;
        });

        SnackbarUtils.success(
          `Route <b>${manifestToReoptimise.route.name}</b> reoptimised. Waiting for other routes to complete...`
        );
      })
      .catch((error) => {
        console.error("Reoptimization failed:", error);
        SnackbarUtils.error(
          `Failed to reoptimise route <b>${manifestToReoptimise.route.name}</b>.`
        );

        // Remove from reoptimizing collection
        setReoptimizingManifests((prev) => {
          const newMap = new Map(prev);
          newMap.delete(manifestToReoptimise.id);
          return newMap;
        });

        // Remove from loading manifests
        setLoadingManifests((prev) =>
          prev.filter((id) => id !== manifestToReoptimise.id)
        );
        setReoptimisingManifestIds((prev) =>
          prev.filter((id) => id !== manifestToReoptimise.id)
        );
      });
  };

  const handleAdvancedReoptimiseRoute = async (manifestToReoptimise: manifest) => {
    if (isRouteInFlight(manifestToReoptimise.id)) {
      SnackbarUtils.info("This route is already being reoptimised.");
      return;
    }

    const undelivered = manifestToReoptimise.manifestLines.filter(
      (line) => line.deliveryStatus !== DeliveryLineStatusValue.COMPLETED
    );
    if (undelivered.length === 0) {
      SnackbarUtils.warning("This route has no undelivered orders to reoptimise.");
      return;
    }

    const body = {
      ...routificSettings,
      routes: [
        {
          id: manifestToReoptimise.routeId,
          manifestId: manifestToReoptimise.id,
          workStartTime: timeFormat(manifestToReoptimise?.driver.workStartTime) || "00:00",
          workEndTime: timeFormat(manifestToReoptimise?.driver.workEndTime) || "23:59",
          breakStartTime: timeFormat(manifestToReoptimise?.driver.breakStartTime) || "",
          breakEndTime: timeFormat(manifestToReoptimise?.driver.breakEndTime) || "",
          returnToDepot: manifestToReoptimise?.driver.returnToDepot || false,
          excludeOptimize: false,
          totalTimeBefore: manifestToReoptimise?.workingTime || 0,
          totalDistanceBefore: manifestToReoptimise?.distance || 0,
          strictStart: false,
        },
      ],
      isApplyUnallocatedDoc: false,
    };

    setLoadingManifests((prev) => [...prev, manifestToReoptimise.id]);
    setReoptimisingManifestIds((prev) => [...prev, manifestToReoptimise.id]);

    const advancedReoptimizePromise = axios
      .post("Delivery/AdvancedOptimize", body)
      .then((res) => {
        const responseData = res?.data?.data || res?.data;
        if (res.data.errorMessage || responseData?.error) {
          throw new Error(
            responseData?.error || res.data.errorMessage || "Reoptimising route failed."
          );
        }

        if (responseData.solution && responseData.solution.length > 0) {
          return {
            manifest: manifestToReoptimise,
            solution: responseData.solution[0] as solution,
            unserved: (responseData.unserved || []) as unserved[],
          };
        }

        throw new Error("No solution returned.");
      });

    setAdvancedReoptimizingManifests((prev) => {
      const newMap = new Map(prev);
      newMap.set(manifestToReoptimise.id, {
        manifest: manifestToReoptimise,
        promise: advancedReoptimizePromise,
      });
      return newMap;
    });

    advancedReoptimizePromise
      .then((result) => {
        setAdvancedReoptimizedResults((prev) => {
          const newMap = new Map(prev);
          newMap.set(manifestToReoptimise.id, result);
          return newMap;
        });

        setAdvancedReoptimizingManifests((prev) => {
          const newMap = new Map(prev);
          newMap.delete(manifestToReoptimise.id);
          return newMap;
        });

        SnackbarUtils.success(
          `Route <b>${manifestToReoptimise.route.name}</b> reoptimised. Waiting for other routes to complete...`
        );
      })
      .catch((error) => {
        console.error("Advanced reoptimization failed:", error);
        SnackbarUtils.error(
          `Failed to reoptimise route <b>${escapeHtml(manifestToReoptimise.route?.name ?? "")}</b>.`
        );

        setAdvancedReoptimizingManifests((prev) => {
          const newMap = new Map(prev);
          newMap.delete(manifestToReoptimise.id);
          return newMap;
        });

        setLoadingManifests((prev) =>
          prev.filter((id) => id !== manifestToReoptimise.id)
        );
        setReoptimisingManifestIds((prev) =>
          prev.filter((id) => id !== manifestToReoptimise.id)
        );
      });
  };

  // Effect to save all reoptimized routes when all are complete
  useEffect(() => {
    // Only save if we have results and no ongoing reoptimizations
    if (reoptimizedResults.size > 0 && reoptimizingManifests.size === 0) {
      const resultsArray = Array.from(reoptimizedResults.values());
      
      // Prepare updated manifests with reoptimized data
      const updatedManifests = resultsArray.map(
        ({ manifest: originalManifest, solution: reoptimizedSolution }) => ({
          ...originalManifest,
          manifestLines: reoptimizedSolution.visits.map((visit, index) => ({
            ...visit.manifestLine,
            position: index,
            arrivalTime: visit.arrivalTime,
            finishTime: visit.finishTime,
          })),
          polylines: reoptimizedSolution.polyline,
          distance: reoptimizedSolution.totalDistanceAfter,
          workingTime: reoptimizedSolution.totalTimeAfter,
        })
      );

      // Clear results immediately to prevent duplicate saves
      setReoptimizedResults(new Map());

      // Save all reoptimized routes in a single batch
      saveEditingRoutes.mutate(updatedManifests, {
        onSuccess: (saveRes) => {
          if (saveRes.errorMessage) {
            SnackbarUtils.error("Applying reoptimised routes failed.");
            setLoadingManifests([]);
            setReoptimisingManifestIds([]);
          } else {
            // Show success message
            if (resultsArray.length === 1) {
              SnackbarUtils.success(
                `Route <b>${resultsArray[0].manifest.route.name}</b> has been reoptimised and saved successfully.`
              );
            } else {
              SnackbarUtils.success(
                `${resultsArray.length} route(s) have been reoptimised and saved successfully.`
              );
            }
            
            // Refresh manifest details
            const manifestIds = updatedManifests.map((m) => m.id);
            setReoptimisingManifestIds((prev) =>
              prev.filter((id) => !manifestIds.includes(id))
            );
            setLoadingManifests((prev) =>
              prev.filter((id) => !manifestIds.includes(id))
            );
            refreshManifestsAfterServerChange(
              manifestIds,
              saveRes.lineChangeList ?? []
            );
          }
        },
        onError: (error) => {
          console.error(error);
          SnackbarUtils.error("Applying reoptimised routes failed.");
          setLoadingManifests([]);
          setReoptimisingManifestIds([]);
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reoptimizedResults, reoptimizingManifests]);

  // Effect to apply all advanced reoptimized routes when all are complete
  useEffect(() => {
    if (
      advancedReoptimizedResults.size > 0 &&
      advancedReoptimizingManifests.size === 0
    ) {
      const resultsArray = Array.from(advancedReoptimizedResults.values());
      const totalUnserved = resultsArray.reduce(
        (sum, { unserved: routeUnserved }) => sum + (routeUnserved?.length ?? 0),
        0
      );

      setAdvancedReoptimizedResults(new Map());

      const manifestIds = resultsArray.map(({ manifest }) => manifest.id);

      const clearReoptimiseLoadingState = () => {
        setReoptimisingManifestIds((prev) =>
          prev.filter((id) => !manifestIds.includes(id))
        );
        setLoadingManifests((prev) =>
          prev.filter((id) => !manifestIds.includes(id))
        );
      };

      Promise.all(
        resultsArray.map(({ manifest, solution: optimizedSolution, unserved: routeUnserved }) =>
          axios
            .post("Delivery/ApplyOptimize", {
              solution: [optimizedSolution],
              unserved: routeUnserved ?? [],
              deliveryDate: manifest.deliveryDate,
            })
            .then((res) => {
              if (res.data.errorMessage) {
                throw new Error(res.data.errorMessage);
              }
            })
        )
      )
        .then(async () => {
          const deliveryDate = resultsArray[0]?.manifest.deliveryDate;

          if (totalUnserved > 0 && deliveryDate) {
            await new Promise<void>((resolve) => {
              fetchUnallocatedList(moment(deliveryDate).format(TIME_FORMAT.REQUEST), {
                onSuccess: (unallocated) => {
                  dispatch(updateUnallocatedDocuments(unallocated.unAllocatedDocs));
                  resolve();
                },
                onError: () => resolve(),
              });
            });
          }

          if (resultsArray.length === 1) {
            SnackbarUtils.success(
              `Route <b>${resultsArray[0].manifest.route.name}</b> has been reoptimised and saved successfully.` +
                (totalUnserved > 0
                  ? ` ${totalUnserved} order(s) moved to Unallocated.`
                  : "")
            );
          } else {
            SnackbarUtils.success(
              `${resultsArray.length} route(s) have been reoptimised and saved successfully.` +
                (totalUnserved > 0
                  ? ` ${totalUnserved} order(s) moved to Unallocated.`
                  : "")
            );
          }

          clearReoptimiseLoadingState();
          await refreshManifestsAfterServerChange(manifestIds);
        })
        .catch((error) => {
          console.error(error);
          SnackbarUtils.error("Applying reoptimised routes failed.");
          clearReoptimiseLoadingState();
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [advancedReoptimizedResults, advancedReoptimizingManifests]);

  // Handle reverse delivery sequence
  const handleReverseSequence = (manifestToReverse: manifest) => {
    // Filter out completed/delivered manifest lines
    const undeliveredLines = manifestToReverse.manifestLines.filter(
      (line) => line.deliveryStatus !== DeliveryLineStatusValue.COMPLETED
    );
    
    const deliveredLines = manifestToReverse.manifestLines.filter(
      (line) => line.deliveryStatus === DeliveryLineStatusValue.COMPLETED
    );

    if (undeliveredLines.length === 0) {
      SnackbarUtils.warning("No undelivered orders to reverse in this route.");
      return;
    }

    if (undeliveredLines.length === 1) {
      SnackbarUtils.info("Route has only one undelivered order, no need to reverse.");
      return;
    }

    // Show loading state
    startRouteETALoading([manifestToReverse.id]);
    setLoadingManifests([manifestToReverse.id]);

    // Reverse only undelivered lines
    const reversedUndeliveredLines = [...undeliveredLines].reverse();

    // Combine delivered lines (keep their order) with reversed undelivered lines
    const newManifestLines = [
      ...deliveredLines,
      ...reversedUndeliveredLines,
    ].map((line, index) => ({
      ...line,
      position: index,
    }));

    // Update manifest with reversed sequence
    const updatedManifest: manifest = {
      ...manifestToReverse,
      manifestLines: newManifestLines,
      polylines: "", // Clear polylines to trigger recalculation
    };

    // Save the reversed route
    saveEditingRoutes.mutate([updatedManifest], {
      onSuccess: (saveRes) => {
        if (saveRes.errorMessage) {
          SnackbarUtils.error("Reversing delivery sequence failed.");
          finishRouteETALoading([manifestToReverse.id]);
          setLoadingManifests([]);
        } else {
          SnackbarUtils.success(
            `Delivery sequence for route <b>${manifestToReverse.route.name}</b> has been reversed successfully.`
          );
          
          // Refresh manifest details
          getManifestDetails.mutate(
            { ids: [manifestToReverse.id] },
            {
              onSuccess: (newManifests: manifest[]) => {
                dispatch(updateManifests({ manifests: newManifests }));
                
                // Refetch ETA and polyline
                getRouteETAWithMapIds([manifestToReverse.id]).then(
                  (ETAs) => {
                    const manifestsWithETA = mergeETAsIntoRoutes(
                      newManifests,
                      ETAs
                    ) as manifest[];
                    dispatch(
                      moveAndApplyManifestLine({
                        manifestsUpdate: manifestsWithETA,
                        lineChangeList: saveRes.lineChangeList,
                      })
                    );
                    finishRouteETALoading([manifestToReverse.id]);
                    setLoadingManifests([]);
                  }
                ).catch((error) => {
                  console.error(error);
                  SnackbarUtils.warning("Some ETA data are temporarily not available.");
                  finishRouteETALoading([manifestToReverse.id]);
                  setLoadingManifests([]);
                });
              },
              onError: (error) => {
                console.error(error);
                SnackbarUtils.error("Failed to refresh route data.");
                finishRouteETALoading([manifestToReverse.id]);
                setLoadingManifests([]);
              },
            }
          );
        }
      },
      onError: (error) => {
        console.error(error);
        SnackbarUtils.error("Reversing delivery sequence failed. Please try again.");
        finishRouteETALoading([manifestToReverse.id]);
        setLoadingManifests([]);
      },
    });
  };

  // Handle moving multiple manifest lines
  const handleMoveMultipleManifestLines = (
    target?: manifest,
    position?: string
  ) => {
    if (!target || !position || selectedManifestLines.length === 0) return;

    setIsMovingMultiple(true);

    const positionNumber = Number(position);
    const affectedManifests: manifest[] = [];

    // Find the target manifest
    const targetManifestOriginal = manifests.find((m) => m.id === target.id);
    if (!targetManifestOriginal) {
      SnackbarUtils.error("No target manifest found");
      setIsMovingMultiple(false);
      return;
    }

    // Create a copy of the target manifest
    let targetManifestCopy: manifest = {
      ...targetManifestOriginal,
      manifestLines: [...targetManifestOriginal.manifestLines],
      polylines: "",
    };

    const manifestLinesMap = new Map<string, manifestLine[]>();
    // Group manifest lines by their current manifest
    // move the manifest lines in the same origin manifest together
    // this might help to avoid shuffling the position of the manifest lines between different origin manifests
    selectedManifestLines.forEach((line) => {
      const currentManifestId = line.manifestId;

      if (currentManifestId) {
        if (!manifestLinesMap.has(currentManifestId)) {
          manifestLinesMap.set(currentManifestId, []);
        }
        const lines = manifestLinesMap.get(currentManifestId);
        if (lines) {
          lines.push(line);
        }
      }
    });

    if (!manifestLinesMap.size) {
      SnackbarUtils.error("No manifest lines to move");
      setIsMovingMultiple(false);
      return;
    }

    // Process each manifest's lines
    let currentPosition = positionNumber - 1;

    // Process all manifest lines
    Array.from(manifestLinesMap.entries()).forEach(([manifestId, lines]) => {
      if (manifestId === target.id) {
        // If source is the same as target, we need to handle differently to avoid duplicating lines
        targetManifestCopy.manifestLines =
          targetManifestCopy.manifestLines.filter(
            (line) => !lines.some((l: manifestLine) => l.id === line.id)
          );
      } else {
        // Get source manifest
        const sourceManifest = manifests.find((m) => m.id === manifestId);

        if (sourceManifest) {
          // Create updated source manifest with lines removed
          const updatedSourceManifest: manifest = {
            ...sourceManifest,
            manifestLines: sourceManifest.manifestLines.filter(
              (line) => !lines.some((l: manifestLine) => l.id === line.id)
            ),
            polylines: "",
          };

          // Add source manifest to affected manifests
          affectedManifests.push(updatedSourceManifest);
        }
      }

      // Add manifest lines to target with increasing positions
      targetManifestCopy = handleMovetoTarget(
        targetManifestCopy,
        currentPosition,
        lines
      );
      currentPosition += lines.length;
    });

    // Reorder positions in the target manifest
    targetManifestCopy = {
      ...targetManifestCopy,
      manifestLines: refillManifestLinePosition(
        targetManifestCopy.manifestLines,
        targetManifestCopy.id
      ),
    };

    // Add target manifest to affected manifests
    affectedManifests.push(targetManifestCopy);

    saveEditingRoutes.mutate(affectedManifests, {
      onSuccess: (res) => {
        const affectedManifestIds = affectedManifests.map((mnf) => mnf.id);
        startRouteETALoading(affectedManifestIds);
        setLoadingManifests(affectedManifestIds);

        SnackbarUtils.success(
          `Move ${selectedManifestLines.length} orders to route <b>${target?.route.name}</b> successfully.`
        );

        setIsMovingMultiple(false);
        setIsOpenMoveMultipleModal(false);
        setSelectedManifestLines([]);

        getManifestDetails.mutate(
          {
            ids: affectedManifests.map((mnf) => mnf.id),
          },
          {
            onSuccess: (newManifests: manifest[]) => {
              setLoadingManifests(
                loadingManifests.filter(
                  (id) => !newManifests.some((mnf) => mnf.id === id)
                )
              );

              const unallocatedNewManifests = manifestLinesMap.get(
                manifestIds.UNALLOCATED
              );

              if (unallocatedNewManifests?.length) {
                dispatch(
                  moveUnallocatedAndUpdateManifests({
                    manifestLineMoving: unallocatedNewManifests,
                    newManifests,
                  })
                );
              } else {
                dispatch(
                  updateManifests({
                    manifests: newManifests,
                  })
                );
              }

              // refetch ETA and polyline
              getRouteETAWithMapIds(newManifests.map((mnf) => mnf.id))
                .then((ETAs) => {
                  const manifestsMovedReplaceETA = mergeETAsIntoRoutes(
                    newManifests,
                    ETAs
                  ) as manifest[];
                  // Replace polyline
                  dispatch(
                    moveAndApplyManifestLine({
                      manifestsUpdate: manifestsMovedReplaceETA,
                      lineChangeList: res.lineChangeList,
                    })
                  );
                  finishRouteETALoading(affectedManifestIds);
                })
                .catch((error) => {
                  console.error(error);
                  SnackbarUtils.warning(
                    "Some ETA data are temporarily not available. Please try again later."
                  );
                  finishRouteETALoading(affectedManifestIds);
                });
            },
            onError: (error) => {
              console.error(error);
              SnackbarUtils.error(
                "The moving process failed. Please try again."
              );
              finishRouteETALoading(affectedManifestIds);
              setIsMovingMultiple(false);
            },
          }
        );
      },
    });
  };

  // Helper function to remove multiple manifest lines from a manifest
  const removeMultipleManifestLines = (
    manifest: manifest,
    manifestLinesToRemove: manifestLine[]
  ): manifest => {
    if (!manifest.manifestLines) return manifest;

    const updatedManifestLines = manifest.manifestLines.filter(
      (line) => !manifestLinesToRemove.some((ml) => ml.id === line.id)
    );

    return {
      ...manifest,
      manifestLines: updatedManifestLines,
    };
  };

  const handleSelectManifestLines = (manifestLines: manifestLine[]) => {
    // Update the selectedManifestLines state and open the modal
    setSelectedManifestLines(manifestLines);
    if (manifestLines.length > 0) {
      setIsOpenMoveMultipleModal(true);
    }
  };

  return (
    <>
      <div className="pb-5 flex items-center">
        <Common.Input
          wrapClassName="2xl:lg:w-[26.375rem] mr-3"
          iconRight={Icon.Search}
          iconType="stroke"
          disabled={loading}
          placeholder="Search customer, route, driver name..."
          value={searchKeyword}
          onChange={(e: any) => setSearchKeyword(e.target.value)}
          onClear={() => setSearchKeyword("")}
        />
        <div className="max-w-[12.5rem]">
          <Common.DatePicker
            disabled={loading}
            selected={startDate}
            onChange={handleChangeDateToFetch}
            onSelect={handleChangeDateFirst}
          />
        </div>
        <span data-tip="Refresh manifest list" className="ml-2">
          <Common.Button
            onClick={handleRefreshList}
            disabled={loading}
            iconLeft={Icon.Reload}
            iconType="stroke"
            id="btnRefreshManifestList"
          />
        </span>
        <StorageAddress />

        <Common.Button
          onClick={handleOptimizeRoutes}
          iconLeft={Icon.Split}
          outline
          splitDropdown
          dropdownItems={[
            {
              label: "Optimize individuals",
              onClick: handleOptimizeIndividuals,
              tooltip:
                "Optimise each selected route individually using Advanced mode.",
            },
          ]}
          data-tip="Select the route and click this button to optimize the way for your route"
          disabled={isOptimizeRoutesDisabled}
          className="whitespace-nowrap"
        >
          Optimize routes
        </Common.Button>

        <Common.Button
          className="ml-3 whitespace-nowrap"
          iconLeft={Icon.Edit}
          outline
          onClick={handleEditRoutesFirst}
          disabled={!routesSelected.length || isETALoading}
        >
          Edit routes
        </Common.Button>
      </div>
      <div className="flex">
        <div className="w-[26.375rem] mr-4 relative">
          <div className="flex items-center mb-1 h-[1.5rem]">
            <Common.Checkbox
              label="ROUTES"
              id="ROUTES"
              ipSize="md"
              disabled={isETALoading || !manifestCanCheck.length}
              wrapClassName={clsx("ml-4", !manifests?.length && "hidden")}
              checked={
                unallocatedDocumentCount
                  ? isCheckedAll && unallocateChecked
                  : isCheckedAll
              }
              onChange={handleCheckAllRoutes}
            />
            <Common.Checkbox
              label="Hide routes without order"
              id="hideEmptyRoute"
              ipSize="md"
              wrapClassName={clsx(
                manifests?.length && "ml-4",
                !manifests?.length && "hidden"
              )}
              checked={isHideEmptyRoute}
              onChange={() => setHideEmptyRoute(!isHideEmptyRoute)}
            />
            <div
              className={clsx(
                "ml-auto",
                (!manifests?.length || (!results.length && !searchKeyword)) &&
                  user.subscribedProductType !==
                    SUBSCRIPTION_PRODUCT_TYPE.TOMDELIVERY &&
                  "hidden"
              )}
            >
              <Common.Button
                size="sm"
                outline
                onClick={() => setIsOpenAddEmptyRouteModal(true)}
              >
                Add route
              </Common.Button>
            </div>
          </div>

          <DeliveryList
            date={date}
            manifests={results}
            isETAsLoading={isETALoading}
            loadingManifests={loadingManifests}
            reoptimisingManifestIds={reoptimisingManifestIds}
            etaLoadingManifestIds={etaLoadingManifestIds}
            routesChecked={routesSelected}
            onCheckRoute={handleSelectRouteList}
            searchKeyword={searchKeyword}
            unallocatedDocumentCount={unallocatedDocumentCount}
            unallocateChecked={unallocateChecked}
            onCheckUnallocate={setUnallocateChecked}
            onChangeDriver={setChangeDriverModal}
            onSwap={setSwapModal}
            onMove={setManifestMoveModal}
            onBasicReoptimise={handleReoptimiseRoute}
            onAdvancedReoptimise={setReoptimiseDialogManifest}
            onReverseSequence={handleReverseSequence}
            onMoveUnallocated={handleMoveToAnotherRouteClick}
            onPreviewOptimizeGroup={setPreviewingOptimizeGroup}
            onCancelOptimize={handleCancelOptimize}
            onAddRoute={() => setIsOpenAddEmptyRouteModal(true)}
          />
        </div>
        <div className="flex-1 rounded bg-neutral-10 flex items-center justify-center relative">
          <div className="z-0 w-full h-full">
            <GoogleMap
              storageAddress={storageAddress}
              manifests={manifestsToDisplayOnMap}
              onMoveRoute={handleMoveToAnotherRouteClick}
              manifestIdsCanMove={manifestIdsCanMove} // disable change route when optimizing
              onSelectManifestLines={handleSelectManifestLines}
            />
          </div>
        </div>
      </div>

      <ModalOptimize
        open={isOpenOptimizeModal}
        onClose={() => setOpenOptimizeModal(false)}
        onSubmit={handleSubmitOptimize}
      />

      <ModalReoptimiseRoute
        open={
          !!reoptimiseDialogManifest || !!optimizeIndividualsManifests?.length
        }
        manifest={reoptimiseDialogManifest}
        manifests={optimizeIndividualsManifests}
        isInFlight={
          optimizeIndividualsManifests?.length
            ? optimizeIndividualsManifests.some((manifestItem) =>
                isRouteInFlight(manifestItem.id)
              )
            : reoptimiseDialogManifest
              ? isRouteInFlight(reoptimiseDialogManifest.id)
              : false
        }
        onClose={() => {
          setReoptimiseDialogManifest(undefined);
          setOptimizeIndividualsManifests(undefined);
        }}
        onAdvanced={handleAdvancedReoptimiseRoute}
        onAdvancedBulk={handleConfirmOptimizeIndividuals}
      />

      <ModalMoveRouteEditScreen
        manifestData={manifestCurrent}
        // Remove unallocate data in first index of route
        manifests={manifests}
        manifestLineData={moveModal}
        open={Boolean(moveModal?.id)}
        onClose={() => setMoveModal({} as manifestLine)}
        onMoveItem={(target, position) =>
          handleMoveManifestLine(target, position, moveModal)
        }
        isMoving={editIsSaving}
        previewingOptimizeGroup={previewingOptimizeGroup}
      />

      <ModalChangeDriver
        open={Boolean(isChangeDriverModal?.id)}
        currentData={isChangeDriverModal}
        onClose={() => setChangeDriverModal({} as manifest)}
        onSubmit={() => {}}
        manifests={manifests}
      />

      <ModalSwap
        open={Boolean(isSwapModal?.id)}
        currentData={isSwapModal}
        onClose={() => setSwapModal({} as manifest)}
        onSubmit={() => {}}
        manifests={manifests}
        onCompleted={handleRefreshList}
      />

      <ModalManifestMove
        open={Boolean(isManifestMoveModal?.id)}
        currentData={isManifestMoveModal}
        onClose={() => setManifestMoveModal({} as manifest)}
        onSubmit={() => {}}
        manifests={manifests}
        onCompleted={handleRefreshList}
        date={startDate}
      />

      <ModalAddEmptyRouteScreen
        open={Boolean(isOpenAddEmptyRouteModal)}
        manifests={manifests}
        routeList={routeList}
        date={startDate}
        onClose={() => setIsOpenAddEmptyRouteModal(false)}
      />

      <ModalMoveMultipleRoutesEditScreen
        open={isOpenMoveMultipleModal}
        manifests={manifests}
        manifestLines={selectedManifestLines}
        isMoving={isMovingMultiple}
        onClose={() => {
          setIsOpenMoveMultipleModal(false);
          setSelectedManifestLines([]);
        }}
        onMoveItems={handleMoveMultipleManifestLines}
        previewingOptimizeGroup={previewingOptimizeGroup}
      />

      <ModalInform
        open={Boolean(modalConfirmCancel)}
        type="warning"
        icon={<Icon.Alert size="24" className="fill-white" />}
        onClose={() => {}}
        title="Unsaved changes detected"
        description={alertEditedMsg}
        groupBtn={
          <div className="text-[1rem] font-semibold text-left flex justify-center mt-8">
            <Common.Button outline color="gray" onClick={handleCancelOptimize}>
              Cancel optimize
            </Common.Button>
            <Common.Button
              className="ml-3"
              color="blue"
              onClick={() => {
                setModalConfirmCancel("");
              }}
            >
              Continue optimize
            </Common.Button>
          </div>
        }
      />
    </>
  );
};
